import { render, staticRenderFns } from "./UpsolvingRating.vue?vue&type=template&id=9eda4c06&scoped=true"
import script from "./UpsolvingRating.vue?vue&type=script&lang=js"
export * from "./UpsolvingRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eda4c06",
  null
  
)

export default component.exports